module.exports = __webpack_public_path__ + "media/images/hero-banner-0251ef2f2ecf0d9c48028cb26d60571e.jpg";